import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpen from '@mui/icons-material/MenuOpen';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

import idotLogo from '../images/IDOT-Logo-White.svg'
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { DrawerOpenContext } from '../context/DrawerOpenContext';

export default function AppBar({ handleDrawer }) {

  // context for when drawer is expanded or minimized
  const open = useContext(DrawerOpenContext);
  const theme = useTheme();
  const location = useLocation();
  const isScreenMediumOrSmaller = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <div style={{
      display: 'flex',
      position: 'relative',
      height: '10vh',
      color: 'white',
      padding: '0.5rem',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: theme.palette.mode === 'light' ? theme.palette.primary.main : '#000000',
      zIndex: theme.zIndex.drawer + 1,
    }}>
      <div style={{display: 'flex'}}>
        { location.pathname === '/' &&
          <IconButton
            color="inherit"
            aria-label="open and close drawer"
            onClick={handleDrawer}
            edge="start"
          >
            { open ? <MenuOpen /> : <MenuIcon /> }
          </IconButton>
        }
        {/* A grid is used to properly place the app text and logos */}
        <img src={idotLogo} alt="IDOT Logo" height='40vh' />
      </div>
      <Typography noWrap component="h1" sx={{ fontSize: '1.5rem', fontWeight: 700 }}>
        {isScreenMediumOrSmaller ? "ILMAT" : "Illinois Mobility Assessment Tool (ILMAT)"}
      </Typography>
      <img src={process.env.PUBLIC_URL + '/TTI-white.svg'} alt="TTI Logo" height='40vh' />
    </div>
  );
}